import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Edit } from 'lucide-react';
import { Button } from '../../ui/button';

const EstimateHeader = ({ estimate, estimateId }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <Link to="/dashboard/estimates">
          <Button variant="outline" size="sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Estimates
          </Button>
        </Link>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Estimate Details</h1>
          <p className="text-gray-600 mt-1">
            {estimate.customer_first_name} {estimate.customer_last_name}
          </p>
        </div>
      </div>
      <Link to={`/dashboard/estimates/${estimateId}/edit`}>
        <Button variant="outline">
          <Edit className="w-4 h-4 mr-2" />
          Edit
        </Button>
      </Link>
    </div>
  );
};

export default EstimateHeader;
